import * as React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { createStructuredSelector } from 'reselect';
import { CommandBar, ICommandBarItemProps } from '@fluentui/react';
import { getClassNames } from './index.classNames';
import { DocumentActions as UiDocumentActions} from '../../../redux/actions/ui';
import { CommandActions as DocumentCommandActions} from '../../../redux/actions/document';
import { CommandActions as DocumentsCommandActions} from '../../../redux/actions/documents';
import {Actions as ModalActions} from '@pwbapps/genericdialog';
import _ from 'lodash'
import { getFilterPanelOpened } from '../../../redux/reducers/ui';
import { Document, getChangeStatusEmptyFileForm, getEmptyCommentFileForm, getEmptyFileForm } from '../../../models/document';
import { getTotal } from '../../../redux/reducers/documents';
import { getStatusValues } from '../../../redux/reducers/sharedData';
import { Status } from '../../../models/status';
import { InternalRoleActionsType, ExternalRoleActionsType, isExternalApp } from '../../../utils/costants';
import { getSelectedProject } from '../../../redux/selectors/project';
import { Project } from '../../../models/project';
import { getContextualDocuments, getSelectedDocument } from '../../../redux/selectors/documents';
import { withTranslation, WithTranslation  } from 'react-i18next';

export interface ContactsProps extends WithTranslation {
    filterPanelOpened: boolean, 
    selectedDocuments: Document[],
    total: number,
    loading: boolean,
    loadingContent: boolean,
    loadingScroll: boolean,
    statusValues: Status[],
    userProjectActions: InternalRoleActionsType[] | ExternalRoleActionsType[],
    selectedProject?: Project,
    selectedDocument?: Document,
    setFilterPanelOpened: typeof UiDocumentActions.setFilterPanelOpened,
    openEditModal: typeof DocumentsCommandActions.openEditModal,
    setOpenModal: typeof DocumentCommandActions.setOpenModal,
    openGenericModal: typeof ModalActions.CommandActions.openModal,
    downloadComments: typeof DocumentsCommandActions.downloadComments,
    downloadFiles: typeof DocumentsCommandActions.downloadFiles,
    downloadExcelReport: typeof DocumentsCommandActions.downloadExcelReport,
    fetchDocuments: typeof DocumentsCommandActions.fetchDocuments,
}

class DocumentsCommandBar extends React.Component<ContactsProps> {
    constructor(props: ContactsProps) {
        super(props);
    }   

    getButtons = () => {
        const { selectedDocuments, selectedDocument, total, selectedProject, openGenericModal, fetchDocuments, loadingContent, loading, loadingScroll, statusValues, userProjectActions, t } = this.props;
        let buttons: ICommandBarItemProps[] = [];
        let selectedDocumentIds = _.map(selectedDocuments, d => d.id as number);
        let approveStatus = _.find(statusValues, a => a.name === 'approved') as Status;
        let approveCommentsStatus = _.find(statusValues, a => a.name === 'approved-comments') as Status;
        let declineCommentsStatus = _.find(statusValues, a => a.name === 'declined-comments') as Status;
        let checkedStatus = _.find(statusValues, a => a.name === 'checked') as Status;
        const commentsExist = (selectedDocuments && selectedDocuments.length > 0) ? _.some(selectedDocuments, d => d.comments && d.comments.length > 0) : true;

        buttons = [   
            ...(((!isExternalApp) || (isExternalApp && selectedProject && !selectedProject.isExternalCheckActive)) &&_.find(userProjectActions, a => a === 'ApprovePending') ? [{
                key: 'approve',
                name: t('Approve'),
                disabled: (selectedDocumentIds.length === 0 || _.some(selectedDocuments, (sd: Document) => !sd.isCurrent || !sd.editable || (sd.purpose && !sd.purpose.isWithApproval) || (sd.purpose && sd.purpose.isWithApproval && sd.status && (sd.status.name === 'approved' || sd.status.name === 'approved-comments' || sd.status.name === 'declined-comments' || sd.status.name === 'canceled'))) || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'changeStatus', contextItem: {newStatus: {...approveStatus}, fileForm: getChangeStatusEmptyFileForm()}})},
                iconProps: {
                    iconName: (approveStatus) ? approveStatus.icon : undefined,
                    style: {color: (approveStatus) ? approveStatus.color : undefined} 
                }
            }] : []),       
            ...((isExternalApp && selectedProject && selectedProject.isApproveWithCommentsStatusActive && _.find(userProjectActions, a => a === 'ApprovePending')) ? [{
                key: 'approveComments',
                name: t('Approve with comments'),
                disabled: (selectedDocumentIds.length !== 1 || (selectedDocument && (!selectedDocument.isCurrent || !selectedDocument.editable || (selectedDocument.purpose && !selectedDocument.purpose.isWithApproval) || (selectedDocument.purpose && selectedDocument.purpose.isWithApproval && selectedDocument.status && (selectedDocument.status.name === 'approved' || selectedDocument.status.name === 'approved-comments' || selectedDocument.status.name === 'declined-comments' || selectedDocument.status.name === 'canceled'))))  || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'changeStatus', contextItem: {newStatus: {...approveCommentsStatus}, fileForm: getEmptyCommentFileForm(), files: []}, optional: true})},
                iconProps: {
                    iconName: (approveCommentsStatus) ? approveCommentsStatus.icon : undefined,
                    style: {color: (approveCommentsStatus) ? approveCommentsStatus.color : undefined} 
                }
            }] : []),  
            ...((isExternalApp && _.find(userProjectActions, a => a === 'DeclinePending')) ? [{
                key: 'decline',
                name: t('Decline'),
                disabled: (selectedDocumentIds.length !== 1 || (selectedDocument && (!selectedDocument.isCurrent || !selectedDocument.editable || (selectedDocument.purpose && !selectedDocument.purpose.isWithApproval ) || (selectedDocument.purpose && selectedDocument.purpose.isWithApproval && selectedDocument.status && (selectedDocument.status.name === 'approved' || selectedDocument.status.name === 'approved-comments' || selectedDocument.status.name === 'declined-comments' || selectedDocument.status.name === 'canceled'))))  || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'changeStatus', contextItem: {newStatus: {...declineCommentsStatus}, fileForm: getEmptyCommentFileForm(), files: []}, optional: true})},
                iconProps: {
                    iconName: (declineCommentsStatus) ? declineCommentsStatus.icon : undefined,
                    style: {color: (declineCommentsStatus) ? declineCommentsStatus.color : undefined} 
                }
            }] : []),     
            ...((((isExternalApp && selectedProject && selectedProject.isExternalCheckActive)) && _.find(userProjectActions, a => a === 'CheckPending')) ? [{
                key: 'check',
                name: t('Check'),
                disabled: (selectedDocumentIds.length === 0 || _.some(selectedDocuments, (sd: Document) => !sd.isCurrent || !sd.editable || (sd.purpose && !sd.purpose.isWithApproval))  || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'changeStatus', contextItem: {newStatus: {...checkedStatus}, fileForm: getChangeStatusEmptyFileForm()}, optional: true})},
                iconProps: {
                    iconName: (checkedStatus) ? checkedStatus.icon : undefined,
                    style: {color: (checkedStatus) ? checkedStatus.color : undefined} 
                }
            }] : []),    
            ...(_.find(userProjectActions, a => a === 'ReadPending') ? [{
                key: 'downlaod',
                name: t('Download'),
                disabled: (loadingContent || loading || loadingScroll),
                iconProps: {
                    iconName: t('Download'),
                },
                subMenuProps: {
                    items: [
                        {
                            key: 'downlaodFiles',
                            name: t('Files'),
                            disabled: (total === 0 || !_.some(selectedDocuments, d => d.files.length > 0) || loadingContent || loading || loadingScroll),
                            onClick: () => { openGenericModal({id: 'fileName', contextItem: {fileName: 'Documents Files', isParent: false}}) },
                            iconProps:  {
                                iconName: 'DownloadDocument'
                            } 
                        },
                        {
                            key: 'downloadComments',
                            name: t('Comments'),
                            disabled: (total === 0 || !commentsExist || loadingContent || loading || loadingScroll),
                            onClick: () => { openGenericModal({id: 'comments', optional: 'Documents Comments'}) },
                            iconProps: {
                                iconName: 'Comment',
                            },
                        }
                    ]
                }          
            }] : []),                         
            {
                key: 'excelReport',
                name: t('Report'),
                disabled: (total === 0 || loadingContent || loading || loadingScroll),
                onClick: () => { openGenericModal({id: 'excelReport', optional: 'Documents Report'}) },
                iconProps: {
                    iconName: 'ExcelDocument',
                    style: {color: "#008000"}
                  },
            },
            {
                key: 'refresh',
                name: t('Refresh'),
                disabled: (loadingContent || loading || loadingScroll),
                onClick: () => { fetchDocuments({}) },
                iconProps: {
                    iconName: 'Refresh',
                },
            }   
        ]
        return buttons;
    };

    getFarButtons = () => {
      const {setFilterPanelOpened, filterPanelOpened, t} = this.props;
      return [
     
        {
          key: 'openPanel',
          name: t('Filters'),
          iconProps: {
            iconName: 'Filter'
          },
          ariaLabel: 'Filters',    
          onClick: () => {setFilterPanelOpened({open: !filterPanelOpened})}      
        },          
      ]; 
  };

    render() {
        const styles = getClassNames();
        return (
            <>
                <CommandBar
                    styles={{root: styles.root, secondarySet: {borderTop: 1}}}
                    items={this.getButtons()}
                    farItems={this.getFarButtons()}
                />
            </>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    filterPanelOpened: getFilterPanelOpened,
    selectedDocuments: getContextualDocuments,
    total: getTotal,
    statusValues: getStatusValues,
    selectedProject: getSelectedProject,
    selectedDocument: getSelectedDocument,
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        setFilterPanelOpened: UiDocumentActions.setFilterPanelOpened,
        setOpenModal: DocumentCommandActions.setOpenModal,
        openGenericModal: ModalActions.CommandActions.openModal,
        openEditModal: DocumentsCommandActions.openEditModal,
        downloadComments: DocumentsCommandActions.downloadComments,
        downloadFiles: DocumentsCommandActions.downloadFiles,
        downloadExcelReport: DocumentsCommandActions.downloadExcelReport,
        fetchDocuments: DocumentsCommandActions.fetchDocuments,
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)((withTranslation()(DocumentsCommandBar)));
